import mattilsynet from './mattilsynet'
import snowchat from './snowchat'
import lab from './lab'
import rusinfo from './rusinfo'
import felleskatalogen from './felleskatalogen'
import diabetes from './diabetes'
import diabetesmistral from './diabetesmistral'
import helsebiblioteket from './helsebiblioteket'
import sexogsamfunn from './sexogsamfunn'

const configs = {
  mattilsynet,
  rusinfo,
  snowchat,
  lab,
  felleskatalogen,
  diabetes,
  diabetesmistral,
  helsebiblioteket,
  sexogsamfunn,
}

export default configs
